import React from 'react';
import Button from '../../components/button/Button';
import { usePopupContext } from '../contexts/PopupContext';
import { navigateToTRCBMAssessment } from '../navigation/navigation';
import DismissiblePopup from './DismissiblePopup';
import { DASHBOARD_PARAMETERS } from '../../constants/dashboard';
import { useAppContext } from '../contexts/AppContext';
import { PERIOD_LABEL } from '../../constants/enrollment';
import { useTRCAppContext } from '../contexts/TRCAppContext';

const CreatePresumedResultPopup = () => {
    const trcApp = useTRCAppContext();
    const {
        actions: { hideCreatePresumedResultPopup },
        params,
    } = usePopupContext();

    const {
        applicationSpecificCallbacks: {
            [trcApp]: {
                [DASHBOARD_PARAMETERS.CREATE_PRESUMED_RESULT_CALLBACK]: createPresumedResult,
            },
        },
        reloadPage,
    } = useAppContext();

    const onCreatePresumedResultClick = _e => {
        createPresumedResult(
            params.presumedResultDetails.classId,
            params.presumedResultDetails.studentId,
            params.presumedResultDetails.currentPeriod,
            params.presumedResultDetails.grade,
            params.presumedResultDetails.application,
        );
        hideCreatePresumedResultPopup();
        reloadPage();
    };

    return (
        <DismissiblePopup
            cssClass="create-presumed-result-popup"
            header="Highest Level Achieved"
            message={
                <span>
                    {params.presumedResultDetails.studentName} scored{' '}
                    {params.presumedResultDetails.performance} on the highest available benchmark
                    text at {PERIOD_LABEL[params.presumedResultDetails.pastPeriod]}. Do you want to
                    skip this screening and report the same proficiency level for{' '}
                    {PERIOD_LABEL[params.presumedResultDetails.currentPeriod]}?
                </span>
            }
            buttons={[
                <Button
                    key="create-presumed-result-button"
                    cssClasses="create-presumed-result-button"
                    onClick={onCreatePresumedResultClick}
                >
                    Yes
                </Button>,
                <Button
                    key="cancel-create-presumed-result-button"
                    cssClasses="cancel-create-presumed-result-button"
                    onClick={navigateToTRCBMAssessment({
                        studentId: params.presumedResultDetails.studentId,
                        classeId: params.presumedResultDetails.classId,
                        period: params.presumedResultDetails.currentPeriod,
                        application: params.presumedResultDetails.application,
                    })}
                >
                    No
                </Button>,
            ]}
            onClose={hideCreatePresumedResultPopup}
        />
    );
};

export default CreatePresumedResultPopup;
